/* Safwa : interactions. Aucune dépendance. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const store = { get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };

  /* ---------- Panneaux (<dialog> natif), fermeture animée ---------- */
  const openDialog = (d) => {
    if (!d || d.open) return;
    d.classList.remove('is-closing');
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDialog = (d) => {
    if (!d || !d.open) return;
    d.classList.add('is-closing');
    setTimeout(() => { d.close(); d.classList.remove('is-closing'); document.documentElement.style.overflow = ''; }, d.classList.contains('zoom') ? 0 : 420);
  };
  $$('dialog').forEach((d) => {
    d.addEventListener('click', (e) => { if (e.target === d) closeDialog(d); });
    d.addEventListener('cancel', (e) => { e.preventDefault(); closeDialog(d); });
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-size-guide], [data-open-menu], [data-open-search], [data-open-filters], [data-close-dialog], [data-to-top]');
    if (!t) return;
    if (t.matches('[data-open-size-guide]')) openDialog($('#size-guide'));
    else if (t.matches('[data-open-menu]')) openDialog($('#menu-drawer'));
    else if (t.matches('[data-open-filters]')) openDialog($('#filters-drawer'));
    else if (t.matches('[data-open-search]')) { openDialog($('#search-overlay')); setTimeout(() => { const i = $('[data-search-input]'); if (i) i.focus(); }, 80); }
    else if (t.matches('[data-to-top]')) window.scrollTo({ top: 0, behavior: 'smooth' });
    else closeDialog(t.closest('dialog'));
  });

  /* ---------- En-tête : plein au défilement, caché en descendant, visible en remontant ---------- */
  const header = $('[data-header]');
  if (header) {
    const overlay = header.classList.contains('header--overlay');
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-solid', !overlay || y > 40);
      const goingDown = y > lastY && y > 500;
      header.classList.toggle('is-hidden', goingDown && !header.matches(':hover'));
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (overlay) {
      header.addEventListener('mouseenter', () => header.classList.add('is-solid'));
      header.addEventListener('mouseleave', onScroll);
      header.addEventListener('focusin', () => header.classList.add('is-solid'));
    }
    onScroll();
  }

  /* ---------- Bandeau : messages qui se relaient ---------- */
  $$('[data-announce]').forEach((a) => {
    const msgs = $$('.announce__msg', a);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Galerie produit : points, compteur, zoom ---------- */
  $$('[data-gallery]').forEach((g) => {
    const wrap = g.parentElement;
    const dots = $$('.gallery__dot', wrap);
    const idx = $('[data-gallery-index]', wrap);
    g.addEventListener('scroll', () => {
      const i = Math.round(g.scrollLeft / g.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      if (idx) idx.textContent = i + 1;
    }, { passive: true });
  });
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-zoom]');
    if (!s) return;
    const d = $('dialog.zoom');
    if (!d) return;
    openDialog(d);
    const slide = $$('.zoom__slide', d)[+s.dataset.zoom];
    if (slide) slide.scrollIntoView({ block: 'start' });
  });
  $$('dialog.zoom').forEach((d) => d.addEventListener('click', (e) => { if (e.target.tagName === 'IMG') closeDialog(d); }));

  /* ---------- Carrousels : flèches et barre de progression ---------- */
  $$('[data-carousel]').forEach((c) => {
    const rail = $('[data-rail]', c);
    if (!rail) return;
    const prev = $('[data-prev]', c), next = $('[data-next]', c), bar = $('[data-progress]', c);
    const step = () => { const card = rail.firstElementChild; return card ? card.getBoundingClientRect().width + 14 : rail.clientWidth; };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const p = max > 0 ? rail.scrollLeft / max : 1;
      if (bar) { const w = Math.max(.12, rail.clientWidth / rail.scrollWidth); bar.style.width = (w * 100) + '%'; bar.style.transform = `translateX(${p * (1 / w - 1) * 100}%)`; }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    };
    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Lookbook : points produits ---------- */
  $$('[data-lookbook]').forEach((lb) => {
    const spots = $$('.spot', lb);
    spots.forEach((s) => {
      if (parseFloat(getComputedStyle(s).getPropertyValue('--x')) > 55) s.classList.add('spot--left');
      const b = $('[data-spot]', s);
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = !s.classList.contains('is-open');
        spots.forEach((o) => { o.classList.remove('is-open'); $('[data-spot]', o).setAttribute('aria-expanded', 'false'); });
        s.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', String(open));
      });
      if (matchMedia('(hover: hover)').matches) {
        s.addEventListener('mouseenter', () => s.classList.add('is-open'));
        s.addEventListener('mouseleave', () => s.classList.remove('is-open'));
      }
    });
    document.addEventListener('click', () => spots.forEach((o) => o.classList.remove('is-open')));
  });

  /* ---------- Collection : nombre de colonnes mémorisé ---------- */
  $$('[data-collection]').forEach((c) => {
    const grid = $('[data-grid]', c);
    const btns = $$('[data-cols]', c);
    const apply = (n) => { grid.dataset.cols = n; btns.forEach((b) => b.classList.toggle('is-active', b.dataset.cols === n)); store.set('safwa-cols', n); };
    btns.forEach((b) => b.addEventListener('click', () => apply(b.dataset.cols)));
    const saved = store.get('safwa-cols');
    if (saved) apply(saved);
  });

  /* ---------- Recherche instantanée (recherche prédictive Shopify) ---------- */
  const sInput = $('[data-search-input]'), sOut = $('[data-search-results]');
  if (sInput && sOut) {
    const initial = sOut.innerHTML;
    let timer, ctrl;
    sInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = initial; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const r = await fetch(`${root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sec = doc.querySelector('.shopify-section') || doc.body;
          sOut.innerHTML = sec.innerHTML;
        } catch (err) { /* recherche annulée ou hors ligne : on garde l'affichage */ }
      }, 220);
    });
  }

  /* ---------- Formulaire produit : variante, prix, stock, bouton, alerte épuisé ---------- */
  $$('[data-product-form]').forEach((root) => {
    const data = $('[data-variants]', root);
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const scope = root.closest('[data-product]') || document;
    const idInput = $('[data-variant-id]', root);
    const btn = $('[data-order-button]', root);
    const btnLabel = $('[data-order-label]', root);
    const defaultLabel = btnLabel ? btnLabel.textContent : '';
    const notify = $('[data-notify]', root);
    const fieldsets = $$('fieldset[data-option-index]', root);
    const selected = () => fieldsets.map((f) => { const c = $('input:checked', f); return c ? c.value : null; });
    const find = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const markUnavailable = (opts) => {
      fieldsets.forEach((f, i) => {
        $$('input', f).forEach((inp) => {
          const test = opts.slice(); test[i] = inp.value;
          const v = find(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    const update = () => {
      const opts = selected();
      const v = find(opts);
      fieldsets.forEach((f) => { const lab = $('[data-option-label]', f), c = $('input:checked', f); if (lab && c) lab.textContent = c.dataset.label || c.value; });
      markUnavailable(opts);
      root.toggleAttribute('data-soldout', !v || !v.available);
      if (!v) { if (btn) btn.disabled = true; return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price], .sticky-buy__price').forEach((p) => { p.textContent = v.price; });
      if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? defaultLabel : 'Épuisé'; }
      const sb = $('[data-sticky-buy] button'); if (sb) sb.disabled = !v.available;
      if (notify) notify.hidden = v.available;
      const badge = $('[data-badge]', scope);
      if (badge) {
        if (!v.available) badge.innerHTML = '<span class="badge badge--soldout">Épuisé</span>';
        else if (v.stock) badge.innerHTML = '<span class="badge badge--low">Il reste ' + v.stock + ' pièce' + (v.stock > 1 ? 's' : '') + '</span>';
        else badge.innerHTML = '';
      }
      if (v.media) {
        const slide = $('[data-media-id="' + v.media + '"]', scope);
        const g = slide && slide.parentElement;
        if (g && g.scrollWidth > g.clientWidth) g.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        else if (slide && innerWidth >= 990) slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      const wa = $('.wa-float');
      if (wa && v.sku && wa.dataset.waBase) {
        const msg = 'Bonjour, une question sur : ' + document.title.split(' · ')[0] + ' (réf. ' + v.sku + ') ' + location.origin + location.pathname;
        wa.href = wa.dataset.waBase + '?text=' + encodeURIComponent(msg);
      }
      if (!document.body.classList.contains('template-landing')) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      }
    };
    fieldsets.forEach((f) => f.addEventListener('change', update));
    markUnavailable(selected());
  });

  /* EasySell vend même une taille épuisée : on arrête le clic avant lui */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#es-popup-button, #es-st, .es-popup-button')) return;
    const form = $('[data-product-form]');
    if (form && form.hasAttribute('data-soldout')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ---------- Barre de commande collée (téléphone) ---------- */
  $$('[data-sticky-buy]').forEach((bar) => {
    /* Bouton principal : celui du thème, ou celui qu'EasySell ajoute dans le formulaire quand le bouton du thème est masqué */
    const getMain = () => $('[data-order-button]') || $('#es-popup-button');
    const watch = $('[data-order-button]') || $('form[action*="/cart/add"]');
    if (!watch) return;
    new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < innerHeight * 3)).observe(watch);
    $('button', bar).addEventListener('click', () => {
      const main = getMain();
      if (!main) return;
      main.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => main.click(), 450);
    });
  });

  /* ---------- Vues récemment ---------- */
  const here = $('[data-recent]');
  const list = store.get('safwa-recent') || [];
  let current = null;
  if (here) {
    try { current = JSON.parse(here.dataset.recent); } catch (e) {}
    if (current) {
      const next = [current].concat(list.filter((p) => p.url !== current.url)).slice(0, 10);
      store.set('safwa-recent', next);
    }
  }
  $$('[data-recent-list]').forEach((sec) => {
    const items = list.filter((p) => !current || p.url !== current.url).slice(0, 8);
    if (!items.length) return;
    const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    $('[data-recent-rail]', sec).innerHTML = items.map((p) =>
      `<article class="card"><a class="card__link" href="${esc(p.url)}"><div class="card__media"><img class="card__img" src="${esc(p.img)}" alt="${esc(p.title)}" loading="lazy"></div>` +
      `<div class="card__info"><p class="card__vendor">${esc(p.vendor)}</p><h3 class="card__title">${esc(p.title)}</h3><p class="card__price">${esc(p.price)}</p></div></a></article>`).join('');
    sec.hidden = false;
  });
})();
